import { render } from "./RuleItem.vue?vue&type=template&id=745e3909"
import script from "./RuleItem.vue?vue&type=script&lang=js"
export * from "./RuleItem.vue?vue&type=script&lang=js"

import "./RuleItem.vue?vue&type=style&index=0&id=745e3909&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__